import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

import { completionChoices } from '../walkthroughSteps';

/**
 * The final step: where to land once setup is done.
 *
 * The answer is persisted as `users.walkthrough_start_destination` and read back
 * by `shouldAutoOpenTutorialMenu`, which is what actually decides whether the
 * Learn Medsender checklist opens. Both choices navigate to `/app` — the
 * tutorial is an overlay, not a route.
 */
const StartStep = ({ launchDestination, onSelect }) => {
  const tutorialSelected = launchDestination === 'tutorial';
  return (
    <div className="walkthrough-compact-step walkthrough-start-step">
      <h2>What would you like to do first?</h2>
      <p>
        {tutorialSelected
          ? 'We will open Learn Medsender when you land, so you can walk through the basics step by step.'
          : 'Go straight to Home, or start with a short guided tutorial.'}
      </p>
      <Radio.Group value={launchDestination} onChange={onSelect}>
        {completionChoices.map((choice) => <Radio key={choice.key} value={choice.key}>{choice.label}</Radio>)}
      </Radio.Group>
    </div>
  );
};

StartStep.defaultProps = {
  launchDestination: 'home',
};

StartStep.propTypes = {
  launchDestination: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default StartStep;
